import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastComponent } from './toast.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [ToastComponent],
  imports: [CommonModule, MatSnackBarModule, MatIconModule, MatButtonModule],
  exports: [ToastComponent],
})
export class ToastModule {}
